export const fileTypesAccepted = [
    '.bmp',
    '.csv',
    '.doc',
    '.docx',
    '.gif',
    '.htm',
    '.html',
    '.jpeg',
    '.jpg',
    '.odc',
    '.odp',
    '.odt',
    '.ots',
    '.p7s',
    '.pdf',
    '.png',
    '.ppt',
    '.pptx',
    '.tif',
    '.tiff',
    '.tsv',
    '.txt',
    '.vcf',
    '.vcs',
    '.xls',
    '.xlsm',
    '.xlsx',
    '.xps',
    '.wav',
    '.json',
];
